import { TextMessageType } from 'models/TextMessage';
import { generateFiltersArray } from './utils';

export const FETCH_TEXT_MESSAGES_REQUEST =
  'app/TextMessages/FETCH_TEXT_MESSAGES_REQUEST';
export const FETCH_TEXT_MESSAGES_SUCCESS =
  'app/TextMessages/FETCH_TEXT_MESSAGES_SUCCESS';
export const FETCH_TEXT_MESSAGES_ERROR =
  'app/TextMessages/FETCH_TEXT_MESSAGES_ERROR';

export const CHANGE_SELECTED_MESSAGE =
  'app/TextMessages/CHANGE_SELECTED_MESSAGE';
export const CHANGE_SELECTED_VARIANT =
  'app/TextMessages/CHANGE_SELECTED_VARIANT';

export const FETCH_VARIANTS_AND_PHONES_REQUEST =
  'app/TextMessages/FETCH_VARIANTS_AND_PHONES_REQUEST';
export const FETCH_VARIANTS_AND_PHONES_SUCCESS =
  'app/TextMessages/FETCH_VARIANTS_AND_PHONES_SUCCESS';
export const FETCH_VARIANTS_AND_PHONES_ERROR =
  'app/TextMessages/FETCH_VARIANTS_AND_PHONES_ERROR';

export const CREATE_TEXT_MESSAGE_REQUEST =
  'app/TextMessages/CREATE_TEXT_MESSAGE_REQUEST';
export const CREATE_TEXT_MESSAGE_SUCCESS =
  'app/TextMessages/CREATE_TEXT_MESSAGE_SUCCESS';
export const CREATE_TEXT_MESSAGE_ERROR =
  'app/TextMessages/CREATE_TEXT_MESSAGE_ERROR';

export const UPDATE_TEXT_MESSAGE_SETTINGS_REQUEST =
  'app/TextMessages/UPDATE_TEXT_MESSAGE_SETTINGS_REQUEST';
export const UPDATE_TEXT_MESSAGE_SETTINGS_SUCCESS =
  'app/TextMessages/UPDATE_TEXT_MESSAGE_SETTINGS_SUCCESS';
export const UPDATE_TEXT_MESSAGE_SETTINGS_ERROR =
  'app/TextMessages/UPDATE_TEXT_MESSAGE_SETTINGS_ERROR';

export const UPLOAD_TEXT_MESSAGE_ATTACHMENT_REQUEST =
  'app/TextMessages/UPLOAD_TEXT_MESSAGE_ATTACHMENT_REQUEST';
export const UPLOAD_TEXT_MESSAGE_ATTACHMENT_SUCCESS =
  'app/TextMessages/UPLOAD_TEXT_MESSAGE_ATTACHMENT_SUCCESS';
export const UPLOAD_TEXT_MESSAGE_ATTACHMENT_ERROR =
  'app/TextMessages/UPLOAD_TEXT_MESSAGE_ATTACHMENT_ERROR';

export const DELETE_TEXT_MESSAGE_ATTACHMENT_REQUEST =
  'app/TextMessages/DELETE_TEXT_MESSAGE_ATTACHMENT_REQUEST';
export const DELETE_TEXT_MESSAGE_ATTACHMENT_SUCCESS =
  'app/TextMessages/DELETE_TEXT_MESSAGE_ATTACHMENT_SUCCESS';
export const DELETE_TEXT_MESSAGE_ATTACHMENT_ERROR =
  'app/TextMessages/DELETE_TEXT_MESSAGE_ATTACHMENT_ERROR';

export const REMOVE_TEXT_MESSAGE_REQUEST =
  'app/TextMessages/REMOVE_TEXT_MESSAGE_REQUEST';
export const REMOVE_TEXT_MESSAGE_SUCCESS =
  'app/TextMessages/REMOVE_TEXT_MESSAGE_SUCCESS';
export const REMOVE_TEXT_MESSAGE_ERROR =
  'app/TextMessages/REMOVE_TEXT_MESSAGE_ERROR';

export const CREATE_VARIANT_REQUEST = 'app/TextMessages/CREATE_VARIANT_REQUEST';
export const CREATE_VARIANT_SUCCESS = 'app/TextMessages/CREATE_VARIANT_SUCCESS';
export const CREATE_VARIANT_ERROR = 'app/TextMessages/CREATE_VARIANT_ERROR';

export const UPDATE_TEXT_MESSAGE_VARIANT_REQUEST =
  'app/TextMessages/UPDATE_TEXT_MESSAGE_VARIANT_REQUEST';
export const UPDATE_TEXT_MESSAGE_VARIANT_SUCCESS =
  'app/TextMessages/UPDATE_TEXT_MESSAGE_VARIANT_SUCCESS';
export const UPDATE_TEXT_MESSAGE_VARIANT_ERROR =
  'app/TextMessages/UPDATE_TEXT_MESSAGE_VARIANT_ERROR';

export const UPLOAD_TEXT_MESSAGE_VARIANT_ATTACHMENT_REQUEST =
  'app/TextMessages/UPLOAD_TEXT_MESSAGE_VARIANT_ATTACHMENT_REQUEST';
export const UPLOAD_TEXT_MESSAGE_VARIANT_ATTACHMENT_SUCCESS =
  'app/TextMessages/UPLOAD_TEXT_MESSAGE_VARIANT_ATTACHMENT_SUCCESS';
export const UPLOAD_TEXT_MESSAGE_VARIANT_ATTACHMENT_ERROR =
  'app/TextMessages/UPLOAD_TEXT_MESSAGE_VARIANT_ATTACHMENT_ERROR';

export const DELETE_TEXT_MESSAGE_VARIANT_ATTACHMENT_REQUEST =
  'app/TextMessages/DELETE_TEXT_MESSAGE_VARIANT_ATTACHMENT_REQUEST';
export const DELETE_TEXT_MESSAGE_VARIANT_ATTACHMENT_SUCCESS =
  'app/TextMessages/DELETE_TEXT_MESSAGE_VARIANT_ATTACHMENT_SUCCESS';
export const DELETE_TEXT_MESSAGE_VARIANT_ATTACHMENT_ERROR =
  'app/TextMessages/DELETE_TEXT_MESSAGE_VARIANT_ATTACHMENT_ERROR';

export const REMOVE_TEXT_MESSAGE_VARIANT_REQUEST =
  'app/TextMessages/REMOVE_TEXT_MESSAGE_VARIANT_REQUEST';
export const REMOVE_TEXT_MESSAGE_VARIANT_SUCCESS =
  'app/TextMessages/REMOVE_TEXT_MESSAGE_VARIANT_SUCCESS';
export const REMOVE_TEXT_MESSAGE_VARIANT_ERROR =
  'app/TextMessages/REMOVE_TEXT_MESSAGE_VARIANT_ERROR';

export const REORDER_TEXT_MESSAGE_VARIANTS_REQUEST =
  'app/TextMessages/REORDER_TEXT_MESSAGE_VARIANTS_REQUEST';
export const REORDER_TEXT_MESSAGE_VARIANTS_SUCCESS =
  'app/TextMessages/REORDER_TEXT_MESSAGE_VARIANTS_SUCCESS';
export const REORDER_TEXT_MESSAGE_VARIANTS_ERROR =
  'app/TextMessages/REORDER_TEXT_MESSAGE_VARIANTS_ERROR';

export const CLONE_TEXT_MESSAGE_REQUEST =
  'app/TextMessages/CLONE_TEXT_MESSAGE_REQUEST';
export const CLONE_TEXT_MESSAGE_SUCCESS =
  'app/TextMessages/CLONE_TEXT_MESSAGE_SUCCESS';
export const CLONE_TEXT_MESSAGE_ERROR =
  'app/TextMessages/CLONE_TEXT_MESSAGE_ERROR';

export const ADD_PHONE_REQUEST = 'app/TextMessages/ADD_PHONE_REQUEST';
export const ADD_PHONE_SUCCESS = 'app/TextMessages/ADD_PHONE_SUCCESS';
export const ADD_PHONE_ERROR = 'app/TextMessages/ADD_PHONE_ERROR';

export const REMOVE_PHONE_REQUEST = 'app/TextMessages/REMOVE_PHONE_REQUEST';
export const REMOVE_PHONE_SUCCESS = 'app/TextMessages/REMOVE_PHONE_SUCCESS';
export const REMOVE_PHONE_ERROR = 'app/TextMessages/REMOVE_PHONE_ERROR';

export const UPDATE_PHONE_REQUEST = 'app/TextMessages/UPDATE_PHONE_REQUEST';
export const UPDATE_PHONE_SUCCESS = 'app/TextMessages/UPDATE_PHONE_SUCCESS';
export const UPDATE_PHONE_ERROR = 'app/TextMessages/UPDATE_PHONE_ERROR';

export const CREATE_SMS_LINK_REQUEST =
  'app/TextMessages/CREATE_SMS_LINK_REQUEST';
export const CREATE_SMS_LINK_SUCCESS =
  'app/TextMessages/CREATE_SMS_LINK_SUCCESS';
export const CREATE_SMS_LINK_ERROR = 'app/TextMessages/CREATE_SMS_LINK_ERROR';

export const SET_FILTERS = 'app/TextMessages/SET_FILTERS';

export const PER_PAGE = 10;

export const INITIAL_FILTERS = generateFiltersArray([
  TextMessageType.NORMAL,
  TextMessageType.ALERT,
]);

export const SET_TEXT_MESSAGES_COUNT =
  'app/TextMessages/SET_TEXT_MESSAGES_COUNT';

export const TEXT_MESSAGE_DEFAULT_STATE = {
  uploadAttachmentLoading: false,
  uploadAttachmentError: null,
};

export const TEXT_MESSAGE_VARIANT_DEFAULT_STATE = {
  uploadAttachmentLoading: false,
  uploadAttachmentError: null,
};
